import { PhotoButton } from './PhotoButton'
import { ReturnButton } from './ReturnButton'
import { ShrinkButton } from './ShrinkButton'
import { UniteButton } from './UniteButton'

export const PackageRequestButtons = ({
  item,
  onUniteRequest,
  onShrinkRequest,
  onPhotoRequest,
  onReturnRequest,
  onCancelUniteRequest,
  onCancelShrinkRequest,
  onCancelPhotoRequest,
  onCancelReturnRequest,
  className,
}) => {
  return (
    <div className={`pc-tools-inner-cont ${className || ''}`}>
      <UniteButton item={item} onUniteRequest={onUniteRequest} onCancelUniteRequest={onCancelUniteRequest} />
      <ShrinkButton item={item} onShrinkRequest={onShrinkRequest} onCancelShrinkRequest={onCancelShrinkRequest} />
      <PhotoButton item={item} onPhotoRequest={onPhotoRequest} onCancelPhotoRequest={onCancelPhotoRequest} />
      <ReturnButton item={item} onReturnRequest={onReturnRequest} onCancelReturnRequest={onCancelReturnRequest} />
    </div>
  )
}
